// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.Vue-Toastification__toast--success.my-custom-toast-class {\n       background-color: black ;\n}\n", ""]);
// Exports
module.exports = exports;
